import { Slot } from "expo-router";
import { NavigationHistoryProvider } from "@/contexts/NavigationHistoryContext";

export default function Layout() {
  return (
    <NavigationHistoryProvider>
      <Slot />
    </NavigationHistoryProvider>
  );
}
